import {GlobeAmericaRegularIcon} from 'shells/icon';

import {PeepTerritorySelectInline} from '../../../../entity-details/peep-details/peep-territory-select-inline';

import {EditFieldWrapper} from './edit-field-wrapper';

interface Props {
    territoryId: string | null | undefined;
    onUpdatePeepTerritory: (territoryId: string | null, territoryName: string | null) => void;
    canAccessSetup: boolean;
}

export function PeepTerritory(props: Props) {
    return (
        <EditFieldWrapper
            icon={GlobeAmericaRegularIcon}
            label='Territory'
            children={
                <PeepTerritorySelectInline
                    territoryId={props.territoryId}
                    onUpdatePeepTerritory={props.onUpdatePeepTerritory}
                    canAccessSetup={props.canAccessSetup}
                />
            }
        />
    );
}
